'use strict';

var skeletonBorderRadiusMapper = require('../../../../../../../../_virtual/skeletonBorderRadiusMapper.cjs');

var hasRequiredSkeletonBorderRadiusMapper;

function requireSkeletonBorderRadiusMapper () {
	if (hasRequiredSkeletonBorderRadiusMapper) return skeletonBorderRadiusMapper.__exports;
	hasRequiredSkeletonBorderRadiusMapper = 1;

	/**
	 * Get the border radius based on the Skeleton type and isCircular flag
	 * @param isCircular
	 * @param type
	 * @returns string
	 */ const getBorderRadius = (isCircular, variant)=>{
	    switch(true){
	        case isCircular:
	        case variant === "avatar":
	            return "circular";
	        case variant === "typography":
	            return "small";
	        default:
	            return "medium";
	    }
	};

	skeletonBorderRadiusMapper.__exports.getBorderRadius = getBorderRadius;
	
	return skeletonBorderRadiusMapper.__exports;
}

exports.__require = requireSkeletonBorderRadiusMapper;
//# sourceMappingURL=skeletonBorderRadiusMapper.cjs.map
